import React from 'react';

export default class HelperText extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <div className="helper-text px-1">{this.props.children}</div>;
	}
}
